import axiosInstance from "app/axiosInstance";
import { KeyActionRequestDto } from "../entities/dtos/key-action-request.dto";

export const blockKey = async ({
  accountId,
  keyId,
  shouldUnassignUser
}: KeyActionRequestDto) => {
  try {
    const body =
      shouldUnassignUser !== undefined
        ? { unassignUser: shouldUnassignUser }
        : {};

    const response = await axiosInstance.post(
      `/accounts/${accountId}/keys/${keyId}/block`,
      body
    );

    return response;
  } catch (e: any) {
    console.error(e);
    throw e;
  }
};
